import script from "./jiejfa-1.vue?vue&type=script&setup=true&lang=js"
export * from "./jiejfa-1.vue?vue&type=script&setup=true&lang=js"

import "./jiejfa-1.vue?vue&type=style&index=0&id=3620367e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3620367e"]])

export default __exports__